// Libraries
import { defaultTo, merge, forEach } from 'lodash'

const queryString = require('query-string')

// CrÃ©ation d'un Ã©lÃ©ment stackable
export const prepareStackElement = ({ screen, ...configs }) => {
  // Valeurs par dÃ©faut de navigation
  const defaultConfig = {
    path: '',
    navigationOptions: {
      title: process.env.REACT_APP_WEBSITE_NAME
    }
  }

  // Merge des valeurs par dÃ©faut
  const screenConfig = merge(defaultConfig, configs)

  // Application des configurations inexistantes du composant
  forEach(screenConfig, (value, config) => {
    screen[config] = defaultTo(screen[config], value)
  })

  return screen
}

// CrÃ©ation d'une stack de navigation
export const prepareStack = stackElements => {
  // CrÃ©ation de la stack de navigation
  const navigationStack = {}

  // Ajout des Ã©crans Ã  la stack de navigation
  forEach(stackElements, (params, routeName) => {
    navigationStack[routeName] = prepareStackElement(params)
  })

  return navigationStack
}

export const matchPathAndParams = (a, b) => {
  if (a.path !== b.path) {
    return false
  }
  if (queryString.stringify(a.params) !== queryString.stringify(b.params)) {
    return false
  }
  return true
}
